import { MainLayout } from "@shared/ui/MainLayout";
import MDBox from "@vendor/components/MDBox";
import { InvoiceListItem } from "../components/InvoiceListItem";

export const ManagementInvoicePage = () => {

    return(
        <MainLayout loading={false}>
            <MDBox py={3}>
                <InvoiceListItem/>
            </MDBox>
        </MainLayout>
    )
}
